// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        account: {
            ...props.parameter,
            requiresActivation: true,
            properties: {
                allowCustomQuotesAccess: props.parameter.allowCustomQuotesAccess,
                allowBillTrustAccess: props.parameter.allowBillTrustAccess,
            },
        },
    };

    const useEmailAsUserName = getSettingsCollection(props.getState()).accountSettings.useEmailAsUserName;
    if (useEmailAsUserName) {
        props.apiParameter.account.userName = props.apiParameter.account.email;
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
